import { Injectable } from '@angular/core';

@Injectable()

export class NonceService {
    private nonce: string = '';
    setNonce(value: string){
        this.nonce = value;
    }
    getNonce(): string {
        return this.nonce;
    }
}


// WEBPACK FOOTER //
// ./src/app/services/nonce.service.ts